import React, { Component } from 'react';

import _ from 'lodash';

import {
    MenuTree, MenuItem, MenuHeader
} from '../../../common/components/layout';

import { verifyPermission } from '../../../helpers/verifyPermission';
import { menuPermissions } from './permissions';

class MenuAdmin extends Component {
    items = menuPermissions;

    renderMenu() {
        return this.items.map((item, index) => {
            if (_.isUndefined(item.type)) {
                if (verifyPermission(item.permissions, null)) {
                    return <MenuItem key={index} path={item.path} label={item.label} icon={item.icon} />
                }
                return null
            }
            else {
                const menuTree = item.items.map((i, index2) => {

                    if (verifyPermission(i.permissions, null)) {
                        return <MenuItem path={i.path} label={i.label} icon={i.icon} />
                    }
                    return null
                });

                if (menuTree.filter((item) => item !== null).length > 0) {
                    return (
                        <MenuTree icon={item.icon} label={item.label}>
                            {menuTree}
                        </MenuTree>
                    )
                }
                else {
                    return null
                }

            }
        })
    }

    render() {
        return (
            <ul className="sidebar-menu">
                <MenuHeader name='Navegação principal' />
                {this.renderMenu()}
            </ul >
        );
    }
}

export default (MenuAdmin);